import createReducer from '../../common/util/createReducer';
import {downloadFile} from '../../common/util/file';
import {ActionTypes} from '../actions';

const INITIAL_STATE = {
  'data': [],
  'loading': false,
};

export const combosReportData = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_COMBOS_DATA_REPORT]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_COMBOS_DATA_REPORT]: (state, action) => ({
      ...state,
      'loading': false,
      'data': action.response.data,
    }),
    [ActionTypes.FETCHED_COMBOS_DATA_REPORT_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'data': [],
    }),
    [ActionTypes.FETCHING_COMBOS_DATA_REPORT_EXCEL]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_COMBOS_DATA_REPORT_EXCEL]: (state, action) => {
      downloadFile(action.response.excel);
      return {
        ...state,
        'loading': false,
      };
    },
    [ActionTypes.FETCHED_COMBOS_DATA_REPORT_EXCEL_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'data': [],
    }),
  })(state, action);
};
